import type { MutableRefObject } from 'react';

import { useCallback, useRef, useState } from 'react';
import { useClickAway } from 'react-use';

type TUseModalProps = {
  disabled?: boolean;
};

type TUseModalReturn = [
  boolean,
  () => void,
  () => void,
  MutableRefObject<null>,
];

const useModal = ({ disabled = false }: TUseModalProps): TUseModalReturn => {
  const ref = useRef(null);
  const [isModalOpen, setModalOpen] = useState(false);

  useClickAway(ref, () => {
    if (isModalOpen) {
      setModalOpen(false);
      // onChange(newValue)
    }
  });

  const openModal = useCallback(() => {
    if (!disabled) {
      setModalOpen(true);
    }
  }, [disabled]);

  const closeModal = useCallback(() => {
    if (!disabled) {
      setModalOpen(false);
    }
  }, [disabled]);

  return [isModalOpen, openModal, closeModal, ref];
};

export default useModal;
